import * as Yup from "yup";
import { validateSelectNumber } from "../common";
import { STATUS_CONFIRM_RESULT_REGISTRATION_DEFAULT } from "@/globals/enums";

export const editMimamoriSchema = Yup.object().shape({
  checkboxStatus: validateSelectNumber(
    STATUS_CONFIRM_RESULT_REGISTRATION_DEFAULT
  ),
});
